<template>
  <div
    ref="container"
    class="h-divider"
    :style="{
      marginLeft: props.margin + 'px',
      width: width
    }"
  >
    <div class="dark-line"></div>
    <div class="light-line"></div>
  </div>
</template>
<script setup lang="ts">
import { onMounted, ref } from 'vue'

const container = ref()
const width = ref('100%')
let inited = false
const props = withDefaults(defineProps<{ margin?: number }>(), { margin: 0 })

function calculate_width(el: Element) {
  const style = getComputedStyle(el)
  const left_pad = parseFloat(style.paddingLeft)
  const right_pad = parseFloat(style.paddingRight)
  width.value = `${
    el.clientWidth - props.margin * 2 - (left_pad + right_pad)
  }px`
}

onMounted(() => {
  const el = container.value.parentElement
  if (!inited) {
    const observer = new ResizeObserver(entries => {
      entries.forEach(() => calculate_width(el))
    })
    inited = true
    observer.observe(el)
  }
  calculate_width(el)
})
</script>
<style scoped>
.dark-line {
  height: 1px;
  width: 100%;
  background-color: var(--color-divider-line1);
}
.light-line {
  height: 1px;
  width: 100%;
  background-color: var(--color-divider-line2);
}
</style>
